import React from 'react';
import LoadingScreen from '../screens/loading';
import AuthenticatedRouter from './authenticated-router';
import GuestRouter from './guest-router';
import useAuth from '../resources/auth/auth-hook'
const Router: React.FC = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated === null) return <LoadingScreen />;

  return isAuthenticated ? <AuthenticatedRouter /> : <GuestRouter />;
};

export default Router;
